import { render, staticRenderFns } from "./FinancialTipsArticle4.vue?vue&type=template&id=52ca805a&scoped=true"
import script from "./FinancialTipsArticle4.vue?vue&type=script&lang=js"
export * from "./FinancialTipsArticle4.vue?vue&type=script&lang=js"
import style0 from "./FinancialTipsArticle4.vue?vue&type=style&index=0&id=52ca805a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca805a",
  null
  
)

export default component.exports